<template>
  <el-container class="wrap">
    <div class="login-box" v-show="show">
      <div class="login-logo">
        <img src="./../../assets/image/schoolicon.png" alt="" />
      </div>
      <div class="login-name">
        电商选品虚拟仿真实验
      </div>
      <div class="login-in">
        <el-form
          label-position="top"
          label-width="80px"
          :model="userForm"
          :rules="rules"
          ref="userForm"
        >
          <div style="position: absolute;z-index: -1">
            <input type="text" v-model="slotUser.name" />
            <input type="password" v-model="slotUser.password" />
          </div>
          <el-form-item
            label="用户名"
            class="login-item"
            style="font-size: 12px"
            prop="user"
          >
            <el-input v-model="userForm.user"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="userForm.password"
              @keyup.enter.native="login('userForm')"
            ></el-input>
          </el-form-item>
          <el-form-item size="mini">
            <div class="login-href">
              <span style="color: red" @click="expertLogin"></span>
              <span
                @click="
                  () => {
                    $refs['register'].resetFields();
                    show = false;
                  }
                "
                >注册</span
              >
              <span @click="$router.push('/')">返回首页</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="submit" @click="login('userForm')">
              登录
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="register-box" :class="{ show: !show }">
      <div class="close-btn" @click="show = true">
        <i class="el-icon-close"></i>
      </div>
      <div class="register-box-title">
        <img src="./../../assets/image/schoolicon.png" alt="" />
        <div class="text">
          电商选品虚拟仿真实验
        </div>
      </div>
      <div class="register-formData">
        <el-form
          :inline="true"
          label-position="top"
          :model="registerData"
          :rules="registerDataRules"
          ref="register"
        >
          <el-form-item style="display: none">
            <el-input type="text"></el-input>
            <el-input type="password"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="userName">
            <el-input v-model="registerData.userName"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="registerData.realName"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="registerData.password"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="学校/班级" prop="schoolName">
            <el-input
              v-model="registerData.schoolName"
              style="width: calc(50% - 4px);margin-right: 8px"
            ></el-input>
            <el-input
              v-model="registerData.className"
              style="width: calc(50% - 4px)"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="password2">
            <el-input
              v-model="registerData.password2"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="学号" prop="studentNo">
            <el-input v-model="registerData.studentNo"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="submit-wrap">
        <div class="btn" @click="register('register')">
          注册
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
export default {
  name: "login",
  data() {
    var validatePassword = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请再次输入密码！"));
      } else {
        if (value !== this.registerData.password) {
          callback(new Error("两次输入密码不一致，请重新输入"));
        }
        callback();
      }
    };
    var validateSchoolClass = (rule, value, callback) => {
      if (this.registerData.schoolName === "") {
        callback(new Error("请输入学校名称"));
      }
      if (this.registerData.className === "") {
        callback(new Error("请输入班级名称"));
      }
      callback();
    };
    return {
      slotUser: {
        name: "",
        password: "",
      },
      show: true,
      userForm: {
        user: "",
        password: "",
      },
      rules: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      registerData: {
        userName: "",
        password: "",
        password2: "",
        realName: "",
        studentNo: "",
        className: "",
        schoolName: "",
      },
      registerDataRules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password2: [
          {
            required: true,
            validator: validatePassword,
            trigger: "blur",
          },
        ],
        realName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        studentNo: [{ required: true, message: "请输入学号", trigger: "blur" }],
        className: [
          { required: true, message: "请输入班级名称", trigger: "blur" },
        ],
        schoolName: [
          { required: true, trigger: "blur", validator: validateSchoolClass },
        ],
      },
    };
  },
  methods: {
    expertLogin() {
      this.userForm.user = "mjxy";
      this.userForm.password = "12345678";
      this.login("userForm");
    },
    login(formname) {
      let _query = this.$route.query;
      this.$refs[formname].validate((v) => {
        if (v) {
          this.$axios.get("/login/logout").then(() => {
            this.$axios.post("/login/process", this.userForm).then((res) => {
              if (res.succeed) {
                localStorage.removeItem("HomeOrigin");
                const version = localStorage.getItem("version");
                version ? localStorage.setItem("version", version) : "";
                this.$router.push({
                  path: "/home",
                  query: Object.assign({}, _query),
                });
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    register(formname) {
      this.$refs[formname].validate((v) => {
        if (v) {
          this.$axios.post("/login/register", this.registerData).then((res) => {
            if (res.succeed) {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.userForm.user = this.registerData.userName;
              this.$refs[formname].resetFields();
              this.show = true;
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;
  height: 100%;
  min-height: 900px;
  background: url("./../../assets/image/bg.jpg");
  position: relative;

  .login-box {
    position: absolute;
    right: 100px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 610px;
    height: 670px;
    padding: 64px;
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #ffffff;
    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);
    opacity: 1;
    border-radius: 31px;

    .login-logo {
      width: 290px;
      margin-bottom: 18px;

      img {
        width: 100%;
      }
    }

    .login-name {
      width: 456px;
      height: 30px;
      font-size: 24px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: bold;
      color: #0960e7;
      opacity: 1;
      margin-bottom: 78px;
    }

    .login-in {
      width: 390px;

      ::v-deep .el-form-item__label {
        width: 80px;
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        color: #748aa1;
      }

      .login-href {
        display: flex;
        justify-content: flex-end;

        span {
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }

          &:last-child {
            margin-right: 0;
          }

          margin-right: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei UI, serif;
          font-weight: 400;
          line-height: 18px;
          color: #748aa1;
          opacity: 1;
        }
      }

      .submit {
        cursor: pointer;
        text-align: center;
        width: 391px;
        height: 51px;
        background: linear-gradient(90deg, #70a0eb 0%, #005be7 100%);
        opacity: 1;
        border-radius: 26px;
        font-size: 16px;
        font-family: Microsoft YaHei UI, serif;
        font-weight: 400;
        line-height: 51px;
        color: #ffffff;
      }
    }
  }

  .register-box {
    position: fixed;
    right: -2000px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 1600px;
    height: 784px;
    background: #ffffff;
    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);
    opacity: 1;
    border-radius: 31px;
    padding-top: 132px;
    transition: all 0.3s linear;
    opacity: 0;

    &.show {
      left: 0;
      right: 0;
      opacity: 1;
      transition: all 0.3s linear;
    }

    .close-btn {
      position: absolute;
      right: 100px;
      top: 100px;
      border-radius: 50%;
      background: #0960e7;
      color: white;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }

    .register-box-title {
      text-align: center;
      margin-bottom: 36px;

      img {
        margin-bottom: 22px;
      }

      .text {
        height: 34px;
        font-size: 27px;
        font-family: Microsoft YaHei UI;
        font-weight: bold;
        color: #0960e7;
      }
    }

    .register-formData {
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .el-form-item {
          width: 460px;
          margin: 0 105px;
          margin-bottom: 24px;
        }
      }

      ::v-deep .el-form-item__label {
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        color: #748aa1;
      }
    }

    .submit-wrap {
      display: flex;
      justify-content: center;

      div.btn {
        cursor: pointer;
        text-align: center;
        width: 391px;
        height: 51px;
        background: linear-gradient(90deg, #70a0eb 0%, #005be7 100%);
        opacity: 1;
        border-radius: 26px;
        font-size: 16px;
        font-family: Microsoft YaHei UI, serif;
        font-weight: 400;
        line-height: 51px;
        color: #ffffff;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
